export const carouselReverse = `<svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="46" height="46" rx="10" fill="#282B34"/>
<path d="M13 23L28 14.3397V31.6603L13 23Z" fill="#00ABC7"/>
</svg>
`;
